import { DropdownOption } from 'types/dropdown';

export const CHARGES_REPORT_MIN_DATE = new Date(2026, 5, 1);

// Asks the org/branch config APIs to also return the report columns available for selection
export const INCLUDE_REPORT_FIELDS_QUERY = '?include_report_fields=true';

// GST report columns that can't be deselected in the column modal
export const mandatoryGstReportColumnKeys = ['paid_by', 'total_amount'];

// Audit log export is capped at one month per request
export const AUDIT_LOG_MAX_RANGE_IN_DAYS = 31;

export const CHARGES_REPORT_DISABLED_DATE_INFO_TEXT =
  'Reports not available, Please connect with account manager';

export enum ReportDateRangeOptionEnum {
  THIS_MONTH = 'this-month',
  LAST_MONTH = 'last-month',
  CURRENT_FINANCIAL_YEAR = 'current-financial-year',
  LAST_FINANCIAL_YEAR = 'last-financial-year',
  CUSTOM = 'custom'
}

export enum ReportTypes {
  GST = 'gst',
  SETTLEMENT = 'settlement',
  CUSTOM = 'custom',
  CHARGES = 'charges',
  AUDIT_LOG = 'audit-log'
}

export const ReportOptions: DropdownOption[] = [
  {
    id: ReportTypes.GST,
    label: 'GST Report',
    value: ReportTypes.GST
  },
  {
    id: ReportTypes.CUSTOM,
    label: 'Collection Report',
    value: ReportTypes.CUSTOM
  },
  {
    id: ReportTypes.CHARGES,
    label: 'Transaction Charges Report',
    value: ReportTypes.CHARGES
  },
  {
    id: ReportTypes.AUDIT_LOG,
    label: 'Audit Log',
    value: ReportTypes.AUDIT_LOG
  }
];

export enum ReportCategory {
  PAYMENT_LINK = 'payment-link',
  PAID = 'paid',
  SETTLEMENT = 'settlement',
  DUE_DATE = 'due-date'
}

export enum ReportGroupBy {
  PAYMENT_LINK = 'payment-link',
  PAID = 'paid',
  SETTLEMENT = 'settlement',
  DUE_DATE = 'due-date',
  MEMBER = 'member'
}

export const CategoryListOption: DropdownOption[] = [
  {
    id: 'paymentLinkGenerated',
    label: 'Payment Link Generated Date',
    value: ReportCategory.PAYMENT_LINK
  },
  {
    id: 'paid',
    label: 'Paid Date',
    value: ReportCategory.PAID
  },
  {
    id: 'settlement',
    label: 'Settled Date',
    value: ReportCategory.SETTLEMENT
  },
  {
    id: 'dueDate',
    label: 'Due Date',
    value: ReportCategory.DUE_DATE
  }
];

export const GroupByListOption: DropdownOption[] = [
  {
    id: 'member',
    label: 'Member',
    value: ReportGroupBy.MEMBER
  },
  {
    id: 'paymentLinkGenerated',
    label: 'Payment Link Generated Date',
    value: ReportGroupBy.PAYMENT_LINK
  },
  {
    id: 'paid',
    label: 'Paid Date',
    value: ReportGroupBy.PAID
  },
  {
    id: 'settlement',
    label: 'Settled Date',
    value: ReportGroupBy.SETTLEMENT
  },
  {
    id: 'dueDate',
    label: 'Due Date',
    value: ReportGroupBy.DUE_DATE
  }
];
